// import FitText from '@kennethormandy/react-fittext'
import { Button, Dropdown, Icon, Menu } from 'antd'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styled from 'styled-components'
import { darken, transparentize } from 'polished'
import TextFit from 'react-textfit'
import { cycleSort, SortOrder } from '../utils'

const ListHeader = styled(Dropdown)`
  &,
  &:active,
  &:hover,
  &:focus {
    background: ${p => p.theme.offBlack};
    color: ${p => p.theme.textWhite};
    border: none;
  }

  width: 100%;
  height: 60px;
  margin-bottom: 15px;
  font-size: 1.4em;

  .anticon.anticon-down {
    font-size: inherit !important;
    margin-left: 10px;
    vertical-align: middle;
  }
`

const SortDir = styled.span`
  display: ${({ active }) => (active ? 'inline' : 'none')};
  margin-left: 6px;
`

const StMenu = styled(Menu)`
  background: ${p => p.theme.antLink};

  .ant-dropdown-menu-item {
    color: ${p => transparentize(0.35, p.theme.textOffwhite)};

    :hover {
      color: ${p => p.theme.textOffwhite};
      background: none;
    }
  }

  .ant-dropdown-menu-item-selected {
    &,
    &:hover {
      background: ${p => darken(0.1, p.theme.antLink)};
      color: ${p => p.theme.textOffwhite};
    }
  }
`

class HostsListHeaderMobile extends Component {
  state = {}

  static propTypes = {
    sortBy: PropTypes.string,
    sortOrder: PropTypes.oneOf([SortOrder.DESC, SortOrder.ASC]),
    onSortChange: PropTypes.func,
    columns: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        columnKey: PropTypes.string.isRequired,
        sorter: PropTypes.func,
      })
    ),
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return {
      mobileMenu: (
        <StMenu
          // theme="dark"
          selectedKeys={[nextProps.sortBy]}
          onClick={({ key }) =>
            nextProps.onSortChange &&
            nextProps.onSortChange(
              nextProps.columns.find(({ columnKey }) => columnKey === key),
              cycleSort(nextProps.sortBy === key && nextProps.sortOrder, false)
            )
          }
        >
          {nextProps.columns
            .filter(col => col.sorter)
            .map(col => (
              <Menu.Item key={col.columnKey}>
                {col.title}
                <SortDir active={col.columnKey === nextProps.sortBy}>
                  {nextProps.sortOrder === SortOrder.ASC
                    ? '↑'
                    : nextProps.sortOrder === SortOrder.DESC
                    ? '↓'
                    : ''}
                </SortDir>
              </Menu.Item>
            ))}
        </StMenu>
      ),
    }
  }

  render() {
    return (
      <ListHeader
        trigger={['click']}
        overlay={this.state.mobileMenu}
        {...this.props}
      >
        <Button>
          <TextFit>
            Sort By{' '}
            {
              this.props.columns.find(
                ({ columnKey }) => columnKey === this.props.sortBy
              ).title
            }
            <Icon type="down" />
          </TextFit>
        </Button>
      </ListHeader>
    )
  }
}

export default styled(HostsListHeaderMobile)`
  box-shadow: ${({ affixed }) =>
    affixed ? '0 7px 13px -5px #6cc0ff' : 'none'};
`



// WEBPACK FOOTER //
// /opt/build/repo/src/components/HostsListHeaderMobile.jsx